import { useQuery } from "@apollo/client";
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getUserResponses } from "../../graphql/queries/onBoarding";
import { apolloClient } from "../../startup/apollo";
import {
  createOnboardingData,
  getOnboardingData,
} from "../../services/onboarding";

export interface OnboardingSubData {
  id: string;
  organizationId: string;
  label: string;
  path: string;
  subSteps: any;
}
export interface FormResponses {
  id: string;
  organizationId: string;
  formResponses: any;
  reviewed: boolean;
}
export interface OnBoardingState {
  activeSubStep: number;
  activeStep: number;
  onBoardingData: OnboardingSubData[];
  loading: boolean;
  error: string | null;
  formResponses: FormResponses;
}
export const initialState = {
  activeSubStep: 1,
  activeStep: 1,
  onBoardingData: [],
  loading: false,
  error: null as string | null,
  formResponses: null,
};

export const fetchOnboardingData = createAsyncThunk(
  "onBoarding/fetchOnboardingData",
  async () => {
    try {
      let response: any = (await getOnboardingData()) as any;
      if (response?.length > 0)
        return response?.filter((_: any, index: number) => index <= 5);
      return await createOnboardingData();
    } catch (error: any) {
      throw new Error(`Failed to fetch onboarding data: ${error.message}`);
    }
  }
);

export const fetchFormResponses = createAsyncThunk(
  "onBoarding/fetchFormResponses",
  async () => {
    try {
      const response = await apolloClient.query({
        query: getUserResponses,
      });
      return response.data.getUserResponses;
    } catch (error: any) {
      throw new Error(`Failed to fetch form response: ${error.message}`);
    }
  }
);

const OnBoardingSlice = createSlice({
  name: "OnBoarding",
  initialState,
  reducers: {
    setActiveSubStep: (state, action: PayloadAction<number>) => {
      state.activeSubStep = action.payload;
    },
    setActiveStep: (state, action: PayloadAction<number>) => {
      state.activeStep = action.payload;
    },
    setonBoardingData(state, action) {
      state.onBoardingData = action.payload;
    },
    setFormResponses(state, action) {
      state.formResponses = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOnboardingData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOnboardingData.fulfilled, (state, action) => {
        state.loading = false;
        state.onBoardingData = action.payload;
      })
      .addCase(fetchOnboardingData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch onboarding data";
      })
      .addCase(fetchFormResponses.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFormResponses.fulfilled, (state, action) => {
        state.loading = false;
        state.formResponses = action.payload;
      })
      .addCase(fetchFormResponses.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch form responses";
        console.error("Error in reducer:", action.error.message);
      });
  },
});

export const {
  setActiveSubStep,
  setActiveStep,
  setonBoardingData,
  setFormResponses,
} = OnBoardingSlice.actions;
export default OnBoardingSlice.reducer;
